module.exports = __webpack_public_path__ + "static/media/banner_fv.09953aad.png";